import React, { useCallback } from "react"
import { connect, Field } from "formik"
import { Translate } from "utils/i18n-shim"
import { Grid, IconButton, Box } from "@mui/material"
import ClearIcon from "@mui/icons-material/Clear"

import { RemoteAutocomplete, TextField } from "shared/ui/berry-jass-formik"
import {
  getCityPropsByIndex,
  getZipPropsByIndex
} from "entities/postal-codes-service"

const LocationComponent = ({ formik, index, disableRemove, onRemove }) => {
  const handleRemove = useCallback(() => {
    onRemove(index)
  }, [index, onRemove])

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
      <Grid container columnSpacing={2}>
        <Grid item xs={4}>
          <Field
            id={`street${index}`}
            name={`locations.${index}.street`}
            fullWidth
            component={TextField}
            label={
              <Translate value="web-shop.create-order-wizard.step1.street" />
            }
            autoComplete="disabled" // custom value to disable chrome autocomplete
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            id={`street_number${index}`}
            name={`locations.${index}.street_number`}
            fullWidth
            component={TextField}
            label={
              <Translate value="web-shop.create-order-wizard.step1.street-number" />
            }
            className="street-number"
            autoComplete="disabled" // custom value to disable chrome autocomplete
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            fullWidth
            required
            id={`zip${index}`}
            name={`locations.${index}.zip`}
            className="zip"
            label={<Translate value="web-shop.create-order-wizard.step1.zip" />}
            component={RemoteAutocomplete}
            {...getZipPropsByIndex(index, formik.values)}
          />
        </Grid>
        <Grid item xs={4}>
          <Field
            required
            id={`city${index}`}
            name={`locations.${index}.city`}
            className="city"
            label={
              <Translate value="web-shop.create-order-wizard.step1.location-city" />
            }
            component={RemoteAutocomplete}
            {...getCityPropsByIndex(index, formik.values)}
          />
        </Grid>
      </Grid>

      <Box>
        <IconButton disabled={disableRemove} onClick={handleRemove}>
          <ClearIcon />
        </IconButton>
      </Box>
    </Box>
  )
}

export const Location = connect(LocationComponent)
